/*!
 * B2B Org Admin layout — mirrors the MAXMRJ Admin layout (Admin.jsx) because that
 * layout renders a real <Sidebar> (the DP layout does not). The Org Admin lands here
 * on the org facility list with sidebar navigation (Facilities, Org Admins).
 */
import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

import "perfect-scrollbar/css/perfect-scrollbar.css";

import withStyles from "@material-ui/core/styles/withStyles";

import Navbar from "components/Navbars/Navbar.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import { orgRoutes } from "admin-routes.js";
import { projectAssets } from "base-routes.js";

import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";

import { DEFAULT_PROFILE_IMG, NO_USERNAME } from "__helpers/constants";
import "react-notifications-component/dist/theme.css";
import { SELECTED_ADNETWORK } from "__helpers/constants";
import GlobalApis from "components/Sidebar/GlobalApis";
import { USER_INFO } from "__helpers/constants";
// First-time onboarding modals (Terms -> BAA -> Set Password), reused from the DP shell.
import ChangePassword from "views/Profile/ChangePassword";
import BAAComponent from "views/CmsPages/BAAComponent";
import TermsComponent from "views/CmsPages/TermsComponent";

class OrgDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.updateUserInfo = this.updateUserInfo.bind(this);
    this.sendAdnetworkData = this.sendAdnetworkData.bind(this);
    this.saveDataToLocalStorage = this.saveDataToLocalStorage.bind(this);

    let userDetail = JSON.parse(localStorage.getItem(USER_INFO));
    let selectedAdnetwork = JSON.parse(localStorage.getItem(SELECTED_ADNETWORK));
    let profileImage = DEFAULT_PROFILE_IMG;
    if (userDetail && userDetail.imageRef) {
      profileImage = userDetail.imageRef;
    }
    let username =
      userDetail && userDetail.firstName
        ? `${userDetail.firstName} ${userDetail.lastName}`
        : NO_USERNAME;

    this.state = {
      userDetail: { profileImage: profileImage, username: username },
      selectedAdnetwork: selectedAdnetwork ? selectedAdnetwork : [],
      localStorageData: {},
      hasError: "",
      mobileOpen: false,
      // First-time gating for newly invited Org Admins (Terms -> BAA -> Set Password),
      // shown here at login rather than when they first open a facility's DP dashboard.
      openModal: false,
      termNcondition: false,
      bbaCondition: false,
    };
  }
  state = {
    image: projectAssets.blur_image,
    color: "blue",
    mobileOpen: false,
  };

  saveDataToLocalStorage = () => {};
  updateUserInfo = (userDetail) => {
    let username = NO_USERNAME;
    let profileImage = DEFAULT_PROFILE_IMG;
    const info = userDetail || JSON.parse(localStorage.getItem(USER_INFO));
    if (info) {
      if (info.profileImage) profileImage = info.profileImage;
      if (info.imageRef) profileImage = info.imageRef;
      username = info.firstName ? `${info.firstName} ${info.lastName}` : NO_USERNAME;
    }
    this.setState({ userDetail: { profileImage, username } });
  };
  sendAdnetworkData = () => {};

  mainPanel = React.createRef();
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return window.location.pathname !== "/admin/maps";
  }
  resizeFunction = () => {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  };
  componentDidMount() {
    window.addEventListener("resize", this.resizeFunction);
    this.checkFirstTimeFlow();
  }

  // Newly invited Org Admins must complete Terms -> BAA -> Set Password at first login,
  // before using the dashboard. Previously this gating lived only in the DP shell, so for an
  // Org Admin (who lands here, not on a DP dashboard) it wrongly fired the first time they
  // opened a facility's DP dashboard. Sequence + persistence mirror the DP dashboard:
  // BAAComponent records Terms+BAA on the backend; ChangePassword clears newUser on success.
  checkFirstTimeFlow = () => {
    const user = JSON.parse(localStorage.getItem(USER_INFO));
    if (!user) return;
    if (!user.termNcondition) {
      this.setState({ termNcondition: true, bbaCondition: false, openModal: false });
    } else if (!user.bbaCondition) {
      this.setState({ termNcondition: false, bbaCondition: true, openModal: false });
    } else if (user.newUser) {
      this.setState({ termNcondition: false, bbaCondition: false, openModal: true });
    }
  };

  handleTNCAgree = () => {
    this.setState({ openModal: false, termNcondition: false, bbaCondition: true });
  };

  handleBAAAgree = () => {
    const user = JSON.parse(localStorage.getItem(USER_INFO));
    if (user) {
      user.termNcondition = true;
      user.bbaCondition = true;
      localStorage.setItem(USER_INFO, JSON.stringify(user));
    }
    if (user && user.newUser) {
      this.setState({ openModal: true, termNcondition: false, bbaCondition: false });
    } else {
      this.setState({ openModal: false, termNcondition: false, bbaCondition: false });
    }
  };

  // ChangePassword (forced mode) persists newUser=false itself; nothing to do on close.
  handleFirstTimeClose = () => {};
  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true });
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      if (this.mainPanel && this.mainPanel.current) {
        this.mainPanel.current.scrollTop = 0;
      }
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFunction);
  }
  render() {
    const { classes, match, ...rest } = this.props;
    const { mobileOpen, color, userDetail, hasError, localStorageData, selectedAdnetwork } = this.state;
    return (
      <div className={classes.wrapper + " admin-panel-cover"} style={{ backgroundColor: "rgb(239, 235, 235)" }}>
        <div className="display-none storage-observation">no change</div>
        <GlobalApis />
        {/* First-time onboarding for newly invited Org Admins (shown at login, not on the
            first DP dashboard open). Sequence: Terms -> BAA -> Set Password. */}
        <ChangePassword
          id="org-change-password-dialog"
          keepMounted
          open={this.state.openModal}
          handleChangePasswordDialog={this.handleFirstTimeClose}
          onClose={this.handleFirstTimeClose}
          value={""}
          allowCloseModal={false}
        />
        <BAAComponent
          open={this.state.bbaCondition}
          handleBAAAgree={this.handleBAAAgree}
        />
        <TermsComponent
          open={this.state.termNcondition}
          handleTNCAgree={this.handleTNCAgree}
        />
        <Sidebar
          role="admin"
          routes={orgRoutes}
          logoText={projectAssets.brandShortName}
          logo={projectAssets.logo}
          image={projectAssets.blur_image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={mobileOpen}
          color={color}
          updateUserInfo={this.updateUserInfo}
          saveDataToLocalStorage={this.saveDataToLocalStorage}
          localStorageData={localStorageData}
          userDetail={userDetail}
          selectedAdnetwork={selectedAdnetwork}
          sendAdnetworkData={this.sendAdnetworkData}
          {...rest}
        />
        <div className={classes.mainPanel} ref={this.mainPanel}>
          <Navbar
            logoText={projectAssets.brandShortName}
            logo={projectAssets.logo}
            role="admin"
            routes={orgRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            updateUserInfo={this.updateUserInfo}
            userDetail={userDetail}
            sendAdnetworkData={this.sendAdnetworkData}
            {...rest}
          />
          {this.getRoute() && !hasError ? (
            <div className={classes.content}>
              <div className={classes.container}>
                <Switch>
                  {orgRoutes.map((prop, key) => (
                    <Route
                      path={prop.basePath + prop.path}
                      key={key}
                      render={(props) => (
                        <prop.component
                          {...props}
                          updateUserInfo={this.updateUserInfo}
                          key={this.props.location.key}
                        />
                      )}
                    ></Route>
                  ))}
                </Switch>
              </div>
            </div>
          ) : (
            "Error During"
          )}
        </div>
      </div>
    );
  }
}

OrgDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  userDetail: PropTypes.object,
};

export default withStyles(dashboardStyle)(OrgDashboard);
